// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".memoCardTextid[data-v-6fc0fd1a]:empty:before{content:attr(placeholder);color:#afafaf}.memoCardTextid[data-v-6fc0fd1a]{border:1px solid #aaa;border-radius:5px;min-width:50px;width:50px;height:35px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
